import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './../../styles/profesional/perfil.css';
import * as globals from './../../components/GlobalScripts.js';
import Sidebar_left from './Sidebar_left';
import { Link } from 'react-router-dom';

const Profesional_perfil = () => {
    let path_api = localStorage.getItem('path_api');
    const [user, setUser] = useState([]);
    const [categoriasOptions, setCategoriasOptions] = useState([]);
    const [estadosCiudades, setEstadosCiudades] = useState([]);
    const [formDataProfile, setFormDataProfile] = useState({
        profesion: 'Tecnologia',
        profesiones: [],
        descripcion: '',
        estado: 'todo el pais',
        ciudad: 'todo el estado'
    });

    useEffect(() => {
        get_categorias();
        get_estados_ciudades();
    }, []);

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            let userParsed = JSON.parse(user_cache);
            setUser(userParsed);

            if (userParsed.profile) {
                if (!Array.isArray(userParsed.profile.profesiones)) {
                    userParsed.profile.profesiones = [];
                }
                setFormDataProfile(userParsed.profile);
            }
        }
    }, []);

    const get_estados_ciudades = () => {
        axios.post(`${path_api}/default/get_estados_ciudades.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setEstadosCiudades(response.data.estados);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se cargaron los estados y ciudades",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar estados y ciudades",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        });
    };

    const get_categorias = () => {
        axios.post(`${path_api}/default/get_categorias.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setCategoriasOptions(response.data.categorias);
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "No se cargaron las categorias", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al cargar las categorias", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
    };

    const handleSubmit_profile = async (e) => {
        e.preventDefault();
        
        const formData = new FormData();
        formData.append('rute', globals.getRuteBackend());
        formData.append('session_id', globals.get_session_id());
        formData.append('keylogin', globals.get_keylogin());
        formData.append('prof', JSON.stringify(formDataProfile));
    
        if (formDataProfile.identificacionFrontal) {
            formData.append('identificacionFrontal', formDataProfile.identificacionFrontal);
        }
        if (formDataProfile.identificacionTrasera) {
            formData.append('identificacionTrasera', formDataProfile.identificacionTrasera);
        }
        globals.openViewCharge();
        axios.post(`${path_api}/update-account/perfil.php`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "Cuenta actualizada.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                localStorage.setItem('user', JSON.stringify(response.data.user));
                setFormDataProfile(response.data.user.profile);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "Tu cuenta no se actualizó",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al actualizar la cuenta",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };
    

    const handleChange_profile = (e) => {
        const { name, type, checked, value, files } = e.target;
        let newValue;
        if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files[0];
        } else {
            newValue = value;
        }
        setFormDataProfile({ ...formDataProfile, [name]: newValue });
    };

    const handleAddProfession = (e) => {
        const profession = e.target.value;
        if (profession && !formDataProfile.profesiones?.includes(profession)) {
            setFormDataProfile(prev => ({
                ...prev,
                profesiones: [...prev.profesiones, profession]
            }));
        }
        e.target.value = "";
    };

    const handleRemoveProfession = (professionToRemove) => {
        setFormDataProfile(prev => ({
            ...prev,
            profesiones: prev.profesiones.filter(p => p !== professionToRemove)
        }));
    };

    return (
        <>
            <div className='container-profesional page-perfil container-section'>
                <div className='left-side'>
                    <Sidebar_left />
                </div>
                <div className="right-side">
                    <form onSubmit={handleSubmit_profile} className="flex-column gap-20">
                        <div className='sticky-form'>
                            <button className="button-primary" type="submit">Guardar</button>
                        </div>
                        <h2>Tu perfil</h2>
                        <h5>Esto ayudá en las busquedas.</h5>
                        <div className="form-group">
                            <label htmlFor="nombre_comercial">Nombre comercial</label>
                            <input
                                type="text"
                                id="nombre_comercial"
                                name="nombre_comercial"
                                value={formDataProfile.nombre_comercial}
                                onChange={handleChange_profile}
                                className="input-primary"
                                placeholder="Nombre de la empresa"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="profesion">Profesión</label>
                            <select
                                id="profesion"
                                name="profesion"
                                value={formDataProfile.profesion}
                                onChange={handleChange_profile}
                                className="input-primary"
                                required
                            >
                                {categoriasOptions.map((categoria, index) => (
                                    <option key={index} value={categoria}>
                                        {categoria}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="profesiones">Profesiones secundarias</label>
                            <select
                                id="profesiones"
                                onChange={handleAddProfession}
                                className="input-primary"
                                defaultValue=""
                            >
                                <option value="" disabled>— Selecciona una profesión —</option>
                                {categoriasOptions
                                    .filter(cat => !formDataProfile?.profesiones?.includes(cat))
                                    .map((categoria, idx) => (
                                        <option key={idx} value={categoria}>
                                            {categoria}
                                        </option>
                                    ))}
                            </select>

                            <div className="selected-professions">
                                {formDataProfile.profesiones?.map((prof, idx) => (
                                    <span key={idx}>
                                        {prof}
                                        <button type="button" onClick={() => handleRemoveProfession(prof)}>x</button>
                                    </span>
                                ))}
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="descripcion">Descripción del perfil</label>
                            <textarea
                                id="descripcion"
                                name="descripcion"
                                value={formDataProfile.descripcion}
                                onChange={handleChange_profile}
                                className="input-primary"
                                placeholder="Describe tu perfil profesional..."
                                rows="4"
                                required
                            />
                        </div>

                        <div className="form-grop-row">
                            <div className="form-group">
                                <label htmlFor="estado">Estado donde realizas tu servicio</label>
                                <select
                                    id="estado"
                                    name="estado"
                                    value={formDataProfile.estado}
                                    onChange={handleChange_profile}
                                    className="input-primary"
                                    required
                                >
                                    <option value="todo el pais">todo el pais</option>
                                    {estadosCiudades.map((item, index) => (
                                        <option key={index} value={item.nombre}>
                                            {item.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="ciudad">Ciudad donde realizas tu servicio</label>
                                <select
                                    id="ciudad"
                                    name="ciudad"
                                    value={formDataProfile.ciudad}
                                    onChange={handleChange_profile}
                                    className="input-primary"
                                    required
                                >
                                    <option value="todo el estado">todo el estado</option>
                                    {(() => {
                                        const selectedState = estadosCiudades.find(
                                            (item) => item.nombre === formDataProfile.estado
                                        );
                                        return selectedState && selectedState.ciudades
                                            ? selectedState.ciudades.map((ciudad) => (
                                                <option key={ciudad.id} value={ciudad.nombre}>
                                                    {ciudad.nombre}
                                                </option>
                                            ))
                                            : null;
                                    })()}
                                </select>
                            </div>
                        </div>

                        <h2>Identificación</h2>
                        {(!formDataProfile?.identificacionFrontal_rute || !formDataProfile?.identificacionTrasera_rute) && (
                            <h5 className='text-red'>Para poder recibir pagos carga ambas imagenes.</h5>
                        )}
                        {(formDataProfile?.identificacionFrontal_rute && formDataProfile?.identificacionTrasera_rute) && (
                            <h5 className='text-green'>Estas listo para recibir pagos.</h5>
                        )}
                        <div className="form-grop-row">
                            <div className="form-group">
                                <label htmlFor="identificacionFrontal">Frontal</label>
                                <input
                                    type="file"
                                    id="identificacionFrontal"
                                    name="identificacionFrontal"
                                    onChange={handleChange_profile}
                                    className="input-primary"
                                    accept="image/*"
                                />
                                {formDataProfile?.identificacionFrontal_rute && (
                                    <img src={path_api + formDataProfile?.identificacionFrontal_rute} />
                                )}
                            </div>
                            <div className="form-group">
                                <label htmlFor="identificacionTrasera">Trasera</label>
                                <input
                                    type="file"
                                    id="identificacionTrasera"
                                    name="identificacionTrasera"
                                    onChange={handleChange_profile}
                                    className="input-primary"
                                    accept="image/*"
                                />
                                {formDataProfile?.identificacionTrasera_rute && (
                                    <img src={path_api + formDataProfile?.identificacionTrasera_rute} />
                                )}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default Profesional_perfil;